/* eslint-disable class-methods-use-this */
export default class Mixin {
    public beforeSetup() {
        return true
    }

    public afterSetup() {
        return true
    }

    public beforeDraw() {
        return true
    }

    public afterDraw() {
        return true
    }
}
